const API_URL = {
	// AUTH api url
	LOGIN: 'Authentication',
	ME: 'AdminUser/Profile',
	LOGOUT: 'auth/logout',
	STATE: 'Region/GetRegionLookup',
	CITY: 'Region/GetRegionChildLookup',
	LOOKUPKEY: 'Lookup/GetAllByLookupKey',
	UPLOADIMAGE: 'ImageFile/UploadImage',
	DELETEIMAGE: 'ImageFile/Delete',
	APROVEIMAGE: 'ImageFile/ApproveImage',
	AMENITY: 'Amenity/GetAmenity',

	DASHBOARD: {},
	FILEPROCESS: {
		TEMPLE: 'FileProcess/GetPaged',
	},

	ADMIN_USERS: {
		LIST: 'AdminUser/GetPaged',
		ADD: 'AdminUser/Add',
		SINGLE: 'AdminUser',
		UPDATE: 'AdminUser/Update',
		DELETE: 'AdminUser/Delete',
		RECOVER: 'Recover/Delete',
		CHANGEPASSWORD: 'AdminUser/ChangePassword',
	},

	ADMIN_SETTINGS: {
		LIST: 'AdminSetting/GetPaged',
		ADD: 'AdminSetting/Add',
		UPDATE: 'AdminSetting/Update',
		SINGLE: 'AdminSetting',
		DELETE: 'AdminSetting/Delete',
	},

	ROLE: {
		LIST: 'AdminRole/GetRoleLookup',
	},

	MERCHANT: {
		LIST: 'Merchant/GetPaged',
		ADD: 'Merchant/Add',
		UPDATE: 'Merchant/Update',
		SINGLE: 'Merchant',
		DELETE: 'Merchant/Delete',
	},

	TEMPLE: {
		BULKIMPORT: 'Temple/ImportTempleList',
		LIST: 'Temple/GetPaged',
		ADD: 'Temple/Add',
		UPDATE: 'Temple/Update',
		SINGLE: 'Temple',
		DELETE: 'Temple/Delete',
		ROUTINEDETAILS: 'TempleTiming/Add',
		GETTEMPLETIMING: 'TempleTiming',
		UPDATEROUTINEDETAILS: 'TempleTiming/Update',
		GETTEMPLEIMAGE: 'ImageFile/GetImagesByRefId',
	},
	ACCOMMODATION: {
		BULKIMPORT: 'Merchant/ImportPropertyList',
		LIST: 'Property/GetPaged',
		ADD: 'Property/Add',
		UPDATE: 'Property/Update',
		SINGLE: 'Property',
		DELETE: 'Property/Delete',
		LOOKUP: 'Merchant/GetMerchantLookup',
		GETACCOMMODATIONIMAGE: 'ImageFile/GetImagesByRefId',
	},
	ROOMCATEGORY: {
		ADD: 'RoomCategory/Add',
		UPDATE: 'RoomCategory/Update',
		SINGLE: 'RoomCategory',
		DELETE: 'RoomCategory/Delete',
		LIST: 'RoomCategory/GetPaged',
		GETROOMCATEGORYIMAGE: 'ImageFile/GetImagesByRefId',
		ROOMCATEGORYLOOKUP: 'RoomCategory/GetRoomCategoryLookup',
	},
	MERCHANTSUBSCRIPTION: {
		ADD: 'Merchantsubscription/Add',
	},
	SUBSCRIPTION: {
		LIST: 'Subscription/GetSubscription',
		SINGLE: 'Subscription',
	},
	REGION: {
		LIST: 'Region/GetPaged',
		ADD: 'Region/Add',
		DELETE: 'Region/Delete',
		SINGLE: 'Region',
		UPDATE: 'Region/Update',
	},
	PUBLICSETTINGS: {
		LIST: 'PublicSetting/GetPaged',
		ADD: 'PublicSetting/Add',
		SINGLE: 'PublicSetting',
		UPDATE: 'PublicSetting/Update',
	},
	PAYMENT: {
		LIST: 'Payment/GetPaged',
		PROPERTYLOOKUP: 'Payment/GetPropertyListByMerchantId'
	},
	BOOKINGINVOICE: {
		LIST: 'BookingInvoice/GetPaged',
		SINGLE: 'BookingInvoice/DownlaodInvoice'
	},
	CUSTOMER: {
		LIST: 'Customer/GetPaged'
	},
	ENQUIRY: {
		LIST: 'Enquiry/GetPaged',
		EXPORT: 'Enquiry/ExportEnquiryRecord'
	}
};

export default API_URL;
